/** A launch belongs to our Discord proxy, not to an arbitrary page with copied query params. */
export function activityHost(hostname: string): boolean {
  return /^\d{17,20}\.discordsays\.com$/.test(hostname)
}

export const inDiscord = activityHost(window.location.hostname)
const launch = new URLSearchParams(window.location.search)
const launchKeys = ['frame_id', 'instance_id', 'platform', 'guild_id', 'channel_id', 'location_id', 'custom_id', 'referrer_id', 'mobile_app_version']

/** Keep the SDK's launch data across in-app navigation. */
export function activityPath(path: string): string {
  if (!inDiscord) return path
  const url = new URL(path, window.location.origin)
  for (const key of launchKeys) {
    const value = launch.get(key)
    if (value !== null) url.searchParams.set(key, value)
  }
  return url.pathname + url.search + url.hash
}
